import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataStorageService } from './../../../../data-storage.service';
import { AvailableComponents } from '../../../../side-bar/enumAvailableComponents';
import { PricingService } from '../../../../pricing.service';
import { ApiService } from '../../../../api.service';
import { SecurityService } from '../../../../security.service';
import { ApiTextService } from '../../../../apiServices/text/text.service';

@Component({
  selector: 'app-flat-rate-hosted',
  templateUrl: './flat-rate-hosted.component.html',
  styleUrls: ['./flat-rate-hosted.component.scss']
})
export class FlatRateHostedComponent implements OnInit, OnDestroy {

  public fixnetMinutes: number;
  public fixnetMobileMinutes: number;
  availableNetworkTypes: string[];



  constructor(public dataStorageService: DataStorageService,
    public securityService: SecurityService,
    private pricing: PricingService,
    private api: ApiService,
    private tApi: ApiTextService) {
    this.availableNetworkTypes = [];
    const aNT = new Set();
    this.dataStorageService.flatRateHostedPricing.forEach(value => aNT.add(value.networkType));
    this.availableNetworkTypes = Array.from(aNT);
  }

  ngOnInit() {
    const element = document.getElementById('flatHosted');
    element.classList.add('active');
    this.dataStorageService.currentComponent = AvailableComponents['FlatRateHOSTED'];

  }

  ngOnDestroy() {
    const element = document.getElementById('flatHosted');
    element.classList.remove('active');
  }

  setValue() {
    if (this.dataStorageService.currentState.businessFlatRateHosted.numberOfFlatRates > this.maxNumberOfFlatRates()) {
      this.dataStorageService.currentState.businessFlatRateHosted.numberOfFlatRates = this.maxNumberOfFlatRates();
    }
    this.api.putFRHosted(this.dataStorageService.currentState.offerID);
  }

  totalMinutes(minutesType: 'fix' | 'mobile'): number {
    const type = this.dataStorageService.currentState.businessFlatRateHosted.chosenType;
    const pricingElement = this.dataStorageService.flatRateHostedPricing.filter(e => e.networkType === type)[0];
    if (pricingElement === undefined && minutesType === 'fix') {
      return this.fixnetMinutes = this.dataStorageService.currentState.businessFlatRateHosted.fixnetMinutes;
    }
    if (pricingElement === undefined && minutesType === 'mobile') {
      return this.fixnetMobileMinutes = this.dataStorageService.currentState.businessFlatRateHosted.fixnetMobileMinutes;
    }
    this.fixnetMinutes = pricingElement.unitFixnetMinutes;
    this.fixnetMobileMinutes = pricingElement.unitMobilenetMinutes;
    if (minutesType === 'fix') {
      return this.fixnetMinutes * this.dataStorageService.currentState.businessFlatRateHosted.numberOfFlatRates;
    } else if (minutesType === 'mobile') {
      return this.fixnetMobileMinutes * this.dataStorageService.currentState.businessFlatRateHosted.numberOfFlatRates;
    }
  }

  calculateCosts(): number {
    const type = this.dataStorageService.currentState.businessFlatRateHosted.chosenType;
    const pricingElement = this.dataStorageService.flatRateHostedPricing.filter(e => e.networkType === type)[0];
    if (pricingElement === undefined) {
      // tslint:disable-next-line:max-line-length
      return (this.dataStorageService.currentState.businessFlatRateHosted.unitMonthlyCost * this.dataStorageService.currentState.businessFlatRateHosted.numberOfFlatRates);
    }
      return (pricingElement.unitMonthlyCost * this.dataStorageService.currentState.businessFlatRateHosted.numberOfFlatRates);
  }

  clearClick() {
    this.dataStorageService.currentState.businessFlatRateHosted.chosenType = this.availableNetworkTypes[0];
    this.dataStorageService.currentState.businessFlatRateHosted.monthlyCost = 0;
    this.dataStorageService.currentState.businessFlatRateHosted.numberOfFlatRates = 0;
    this.api.putFRHosted(this.dataStorageService.currentState.offerID);
  }

  minNumberOfFlatRates(): number {
    const type = this.dataStorageService.currentState.businessFlatRateHosted.chosenType;
    const pricingElement = this.dataStorageService.flatRateHostedPricing.filter(e => e.networkType === type)[0];
    if (pricingElement === undefined) {
      return 0;
    } else {
      return pricingElement.countMin;
    }
  }

  maxNumberOfFlatRates(): number {
    const type = this.dataStorageService.currentState.businessFlatRateHosted.chosenType;
    const pricingElement = this.dataStorageService.flatRateHostedPricing.filter(e => e.networkType === type)[0];
    if (pricingElement === undefined) {
      return 100;
    } else {
      return pricingElement.countMax;
    }
  }

  updateText(event, key: string) {
    const value = event.target.value;
    this.tApi.putUIText(key, value);
    this.dataStorageService.setUIText(key, value);
  }

  getAvailableNetworkTypes() {
    if (this.availableNetworkTypes.includes(this.dataStorageService.currentState.businessFlatRateHosted.chosenType)) {
      this.dataStorageService.currentState.businessFlatRateHosted.editable = true;
      return this.availableNetworkTypes;
    }
    this.dataStorageService.currentState.businessFlatRateHosted.editable = false;
    return this.availableNetworkTypes.concat([this.dataStorageService.currentState.businessFlatRateHosted.chosenType]);
  }

  getDesc() {
    return this.dataStorageService.filterUIText('offer.options.biz-flrat-hosted.desc');
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/business-flat-rates/flat-rate-hosted/flat-rate-hosted.component.ts